/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch, money } from '../../utils/util';
import { Elements, StripeProvider, CardElement, injectStripe } from 'react-stripe-elements';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './BookChargeForm.css';

import {
} from '../../actions';


class BookChargeForm extends OzFormComponent {

  static fields = [
    'numSlots',
    'privacy',
    'paymentType',
    'notes',
  ];

  componentDidUpdate(prevProps, prevState, snapshot) {
    super.componentDidUpdate(prevProps, prevState, snapshot);
    console.log('debug componentDidUpdate:', prevProps, prevState, snapshot);

    let numSlotsDidChange;
    let newValue;
    if (this.state) {
      newValue = this.state.numSlots;
    }
    if (newValue && !prevState) {
      numSlotsDidChange = true;
    } else if (newValue && !prevState.numSlots) {
      numSlotsDidChange = true;
    } else if (newValue != prevState.numSlots) {
      numSlotsDidChange = true;
    } else {
      numSlotsDidChange = false;
    }

    if (numSlotsDidChange) {
      this.refreshPrice();
    }
  }

  refreshPrice() {
    let bookableSlot = this.props.bookableSlot;
    let params = {
      bookableSlotId: bookableSlot.id,
      numSlots: this.state.numSlots,
    }
    this.props.calculatePrice(params);
  }

  capture() {
    return this.state.paymentType == 'credit_card';
  }

  price() {
    let bookableSlot = this.props.bookableSlot;
    switch(this.state.privacy) {
      case 'public':
        return bookableSlot.prices[this.state.numSlots].price;
        break;
      case 'private':
        return bookableSlot.prices[this.state.numSlots].pricePrivate;
        break;
    }
  }

  renderCreditCardForm() {
    return (
      <div className="credit-card">
        <CardElement className="card" />
      </div>
    );
  }

  renderPayment() {
    if (!this.state.numSlots || !this.state.privacy) {
      return null;
    }

    let price = this.price();

    let paymentTypeOptions = [
      ['credit_card', 'Credit Card'],
      ['cash_check', 'Cash/Check'],
      ['free', 'Free'],
      ['other', 'Other'],
    ];

    return (
      <div className="payment-section">
        <div className="price-wrapper">
          <div className="text">Total price</div>
          <div className="spacer"></div>
          <div className="price">{money(price, 'USD')}</div>
        </div>

        <div className="payment-type">
          {this.renderFormGroup('Form of payment', 'pills', 'paymentType', paymentTypeOptions, { helptext: 'How should we process payment for this booking?' })}

          {this.capture() && this.renderFormGroup('Customer name', 'text', 'name')}
          {this.capture() && this.renderCreditCardForm()}

          {!this.capture() && this.state.paymentType && this.renderFormGroup(null, 'text', 'notes', { placeholder: 'Notes (optional)' })}

        </div>
      </div>
    );
  }

  getValues() {
    let values = super.getValues();
    values.displayedPrice = this.price();
    return values;
  }

  submit(e) {
    e.preventDefault();
    if (this.props.disabled) return;
    if (this.capture()) {
      this.props.stripe.createToken({ name: this.state.name })
        .then(s => {
          if (s.error) return;
          let values = this.getValues();
          values.stripeToken = s.token;
          this.props.onSubmit(e, values);
        });
    } else {
      this.props.onSubmit(e, super.getValues());
    }
  }

  renderButtons() {
    if (!this.state.numSlots ||
        !this.state.privacy ||
        !this.state.paymentType) {
      return null;
    }

    let copy;
    if (this.capture()) {
      copy = 'Charge ' + money(this.price(), 'USD') + ' and Book';
    } else {
      copy = 'Record Payment and Book';
    }

    return (
      <div className="BookChargeForm">
        <FormGroup className="oz-form-buttons">
          <Button bsStyle="default" onClick={(e) => this.props.onCancel(e)}>Cancel</Button>{' '}
          <Button bsStyle="primary" type="submit">{copy}</Button>
        </FormGroup>
      </div>
    );
  }

  renderBody() {
    let bookableSlot = this.props.bookableSlot;

    let numSlotsOptions = [];
    for (let i = 1; i <= bookableSlot.slotsLeft; i++) {
      numSlotsOptions.push([i, i]);
    }

    let roomPrivacy = bookableSlot.room.privacy;
    let privacyOptions = [];
    if (['fee', 'no'].includes(roomPrivacy)) {
      privacyOptions.push(['public', 'Public']);
    }
    if (['fee', 'always'].includes(roomPrivacy)) {
      privacyOptions.push(['private', 'Private']);
    }

    return (
      <div className="BookChargeForm">
        <div><b>Currently booked:</b> {bookableSlot.slotsBooked}</div>
        <div><b>Slots left:</b> {bookableSlot.slotsLeft}</div>
        <div><b>Room privacy setting:</b> {bookableSlot.room.privacy}</div>
        {/*
        <div><b>Min players:</b> {bookableSlot.room.minPeople}</div>
        <div><b>Max players:</b> {bookableSlot.room.maxPeople}</div>
        */}

        <hr/>

        {this.renderFormGroup('How many slots to book?', 'pills', 'numSlots', numSlotsOptions, { helptext: 'The number of additional slots to book.' })}

        {this.renderFormGroup('What type of booking?', 'pills', 'privacy', privacyOptions, { helptext: 'Select whether this booking is private, and may change the price.' })}

        {this.renderPayment()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default injectStripe(connect(mapStateToProps, mapDispatchToProps)(BookChargeForm));



/** WEBPACK FOOTER **
 ** ./src/components/partials/BookChargeForm.js
 **/